export default {
  primary: '#15A8FF',
  success: '#28C76F',
  danger: '#EA5455',
  warning: '#FF9F43',
  dark: '#1E1E1E',
  link: '#0000ee',
};
